import { Star, Quote, ExternalLink } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const GOOGLE_REVIEWS_URL = "https://g.page/r/CYNCxssXp0xCEBM/review";

// Estrutura pronta para receber avaliações REAIS do Perfil da Empresa no Google.
// Nenhuma avaliação fictícia é exibida.
const REVIEWS = [];

export const Reviews = () => {
  return (
    <section id="avaliacoes" className="relative py-24 md:py-32">
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <span className="text-brand font-display text-lg font-bold uppercase tracking-[0.2em]">Avaliações</span>
          <h2 className="mt-3 font-display text-4xl md:text-6xl font-black text-white leading-[0.92]">
            Quem chama a DG Guinchos recomenda
          </h2>
        </Reveal>

        {REVIEWS.length > 0 ? (
          <div className="mt-12 grid md:grid-cols-3 gap-4">
            {REVIEWS.map((r, i) => (
              <Reveal key={i} delay={i * 0.08} className="bg-surface border border-white/10 rounded-sm p-6">
                <Quote className="h-8 w-8 text-brand/60" />
                <p className="mt-4 text-zinc-300">{r.text}</p>
                <div className="mt-4 flex items-center gap-1 text-brand">
                  {Array.from({ length: 5 }).map((_, s) => <Star key={s} className="h-4 w-4 fill-current" />)}
                </div>
                <div className="mt-3 font-display text-lg font-bold text-white">{r.name}</div>
              </Reveal>
            ))}
          </div>
        ) : (
          <Reveal delay={0.1} className="mt-12">
            <div className="relative bg-surface border border-dashed border-white/15 rounded-sm p-10 md:p-14 text-center">
              <div className="mx-auto flex items-center justify-center gap-1.5 text-brand">
                {Array.from({ length: 5 }).map((_, s) => <Star key={s} className="h-7 w-7 fill-current" />)}
              </div>
              <p className="mt-5 max-w-xl mx-auto text-zinc-400 text-lg">
                As avaliações reais dos clientes da DG Guinchos serão exibidas aqui, diretamente
                do Perfil da Empresa no Google. Deixe também a sua!
              </p>
              <a
                href={GOOGLE_REVIEWS_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-google-btn"
                className="mt-8 inline-flex items-center gap-2.5 bg-white hover:bg-zinc-200 text-black font-display font-bold uppercase tracking-wider text-lg px-8 py-4 rounded-sm transition-all active:scale-95"
              >
                <ExternalLink className="h-5 w-5" /> Ver Avaliações no Google
              </a>
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
};
